import React from "react"
import Checkbox from "./Checkbox"
import Radio from "./Radio"
import moment from 'moment'

import xlsx from "xlsx"
import { jsPDF } from "jspdf"
import { autoTable } from "jspdf-autotable"

export const addExpandedRowFunction = (hooks, expandedContentIconOpen, expandedContentIconClosed) => {
  hooks.visibleColumns.push((columns) => {
    return [
      {
        Header: () => null,
        id: "expander",
        width: 50,
        Cell: ({ row }) => (
          <div className="tableCenteredItem" {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? expandedContentIconOpen : expandedContentIconClosed}
          </div>
        ),
      },
      ...columns,
    ]
  })
}

export const addRowSelectionFunction = (hooks, type, onSelectRadioRow) => {
  hooks.visibleColumns.push((columns) => [
    {
      id: 'selection',
      width: 50,
      Header: ({ getToggleAllRowsSelectedProps }) => type === "checkbox" ? <Checkbox {...getToggleAllRowsSelectedProps()} />: "",
      Cell: ({ row, toggleAllRowsSelected }) => {
        return (
          <div
            className="tableCenteredItem"
            onClick={(e) => e.stopPropagation()}
          >
          {type === "checkbox"
            ? 
              <Checkbox 
                {...row.getToggleRowSelectedProps()}
              />
            :
              row.isGrouped 
                ?
                <div></div>
                :
                  <Radio 
                    onClick={() => {
                      toggleAllRowsSelected(false)
                      // onSelectRadioRow(row.id)
                    }}
                    {...row.getToggleRowSelectedProps()} 
                  />
          }
          </div>
        )
      },
    },
    ...columns,
  ])
}

export const exportTable = ({ columns, data, fileType, fileName, styles }) => {
  if (fileType === "csv") {
    // CSV example
    let csvString = "\ufeff"
    const headerNames = columns.map((col) => col.Header).join(";") + "\n"
    csvString += headerNames
    data.map((row) => {
      const values = Object.values(row.values).map((value, index) => {
        const { type = "" } = columns[index]
        if(type === "date")
          return moment(value, 'x').format('DD/MM/YYYY')
        else
          return value
      })
      csvString += values.join(";") + "\n"
    })
    const blob = new Blob([csvString], { type: "text/csv" })
    var link = document.createElement("a")
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", fileName + ".csv")
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    return false
  } else if (fileType === "xlsx") {
    // XLSX example

    const header = columns.map((c) => c.Header)
    const compatibleData = data.map((row) => {
      const obj = {}
      header.forEach((col, index) => {
        let value = Object.values(row.values)[index]
        const { type = "" } = columns[index]
        if(type === "date")
          value = moment(value, 'x').format('DD/MM/YYYY')
        obj[col] = value
      })
      return obj
    })

    let wb = xlsx.utils.book_new()
    let ws1 = xlsx.utils.json_to_sheet(compatibleData, {
      header,
    })
    xlsx.utils.book_append_sheet(wb, ws1, "export")
    xlsx.writeFile(wb, `${fileName}.xlsx`)

    // Returning false as downloading of file is already taken care of
    return false
  }
  //PDF example
  if (fileType === "pdf") {
    const headerNames = columns.map((column) => column.Header)
    const values = data.map((row) =>  (Object.values(row.values).map((value, index) => {
      const { type = "" } = columns[index]
      if(type === "date")
        return moment(value, 'x').format('DD/MM/YYYY')
      else
        return value
    })))
    const doc = new jsPDF({ orientation: "landscape" })
    autoTable(doc, {
      head: [headerNames],
      headStyles: styles.headStyles,
      body: values,
      margin: { top: 20 },
      styles: {
        minCellHeight: 9,
        halign: "left",
        valign: "center",
        fontSize: 11,
      },
    })
    const numberOfPages = doc.internal.getNumberOfPages()
    for (let i = 1; i <= numberOfPages; i++) {
      doc.setPage(i)
      doc.text(140, 205, `Page ${i} of ${numberOfPages}`)
    }
    doc.save(`${fileName}.pdf`)

    return false
  }

  // Other formats goes here
  return false
}